import { useEffect, useState } from 'react'

import Api from 'services/api'
import { PaywallStatement } from 'types/PaywallStatement'

const usePaywallStatements = (dealerId) => {
  const [statements, setStatements] = useState<Array<PaywallStatement>>(Array<PaywallStatement>)
  const [areStatementsLoaded, setAreStatementsLoaded] = useState(false)

  useEffect(() => {
    Api.Paywall.getStatements(dealerId)
      .then(res => {
        setStatements(res)
      }).catch(() => {
        setAreStatementsLoaded(true)
      })
      .finally(() => setAreStatementsLoaded(true))
  }, [dealerId])

  return { statements, areStatementsLoaded }
}

export default usePaywallStatements
